import React, { useState } from "react"

import { useLocalization } from "@izettle/tenko-react"

import CountryModal from "./modal"

type CountryModalButtonProps = {
  onSelect: (_newCountryCode: string) => void
}

export const CountryModalButton: React.FC<CountryModalButtonProps> = ({
  children,
  onSelect,
}) => {
  const [isVisible, setVisible] = useState(false)
  const { text } = useLocalization()

  const handleOnClose = () => {
    setVisible(false)
  }
  const handleButtonClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
    setVisible(true)
  }
  const handleButtonKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      setVisible(true)
    }
  }

  const handleSelect = (newCountryCode: string) => {
    onSelect(newCountryCode)
    handleOnClose()
  }

  return (
    <>
      <div
        onClick={handleButtonClick}
        onKeyDown={handleButtonKeyDown}
        role="button"
        tabIndex={0}
        aria-label={text("signup_country_code_selected", [children as string])}
      >
        {children}
      </div>
      <CountryModal
        isVisible={isVisible}
        onClose={handleOnClose}
        onSelect={handleSelect}
      />
    </>
  )
}
